var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsContentLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00009 11.3088C7.00009 10.3883 7.74628 9.6421 8.66675 9.6421L16.3667 9.6421L12.3574 5.63288C11.8421 5.11752 11.8421 4.28196 12.3574 3.7666C12.8728 3.25124 13.7083 3.25124 14.2237 3.7666L20.3075 9.85038C20.5485 9.98408 20.7528 10.1758 20.9017 10.4066C20.9596 10.4481 21.0149 10.4949 21.0669 10.5469C21.3334 10.8134 21.4621 11.1655 21.4529 11.5147C21.4603 11.8617 21.3315 12.2111 21.0667 12.4759C20.9836 12.559 20.8921 12.6288 20.795 12.6851L14.2239 19.2562C13.7085 19.7716 12.8729 19.7716 12.3576 19.2562C11.8422 18.7408 11.8422 17.9053 12.3576 17.3899L16.7721 12.9754L8.66675 12.9754C7.74628 12.9754 7.00009 12.2292 7.00009 11.3088Z",
    fill: "red"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.64209,
    width: 14.1667,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(90 4.5 4.64209)",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsContentLogout);
export default __webpack_public_path__ + "static/media/icons-content-logout.f575b14f0b387fd25b4162cff4aa0487.svg";
export { ForwardRef as ReactComponent };